import GET_USER_LOCAL_TOURS from './GetUserLocalTours.graphql'
import DELETE_LOCAL_TOUR from './DeleteLocalTour.graphql'

export { GET_USER_LOCAL_TOURS, DELETE_LOCAL_TOUR }



// WEBPACK FOOTER //
// src/graphql/ActivityList/index.js